import { FC } from 'react'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router'
import { checkIsActive, WithChildren } from '../../../../helpers'
import { useSidebar } from '../Sidebar'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  onClick?: () => void
}

const SidebarMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet = false,
  onClick,
}) => {
  const { pathname } = useLocation()
  const { collapsed } = useSidebar()
  const isActive = checkIsActive(pathname, to)

  return (
    <div className='mb-1'>
      <Link
        className={clsx(
          'flex w-full items-center rounded-lg text-xs font-normal transition-colors no-underline py-3',
          collapsed ? 'justify-center px-2' : 'gap-3 px-3',
          isActive
            ? 'bg-white/10 text-white'
            : 'text-gray-400 hover:bg-white/10 hover:text-white'
        )}
        to={to}
        title={title}
        onClick={onClick}
      >
        {hasBullet && (
          <span className='w-1.5 h-1.5 rounded-full bg-current shrink-0' />
        )}
        {icon && (
          <img
            src={icon}
            className={clsx('h-6 w-6 shrink-0 object-contain', isActive ? 'opacity-100' : 'opacity-60')}
            height={24}
            width={24}
            alt=''
          />
        )}
        {fontIcon && <i className={clsx('bi fs-3', 'w-[52px] h-[52px]', fontIcon)} />}
        {!collapsed && (
          <span
            className={clsx(
              'text-left leading-tight text-[15px] font-medium',
              isActive ? 'text-white' : 'text-gray-400'
            )}
          >
            {title}
          </span>
        )}
      </Link>
      {children}
    </div>
  )
}

export { SidebarMenuItem }
